import React, { useState, useEffect } from 'react';
 
const Carousel = () => {
  // Define the images
  const images = [
    'images/review.png',
    'images/review1.png',
    'images/review2.jpg',
    'images/review3.png',
    'images/review4.png',
    'images/review5.png',
    'images/review6.jpg',
    'images/review7.png',
    'images/review8.png',
    
  ];
 
  const [currentIndex, setCurrentIndex] = useState(0);
 
  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);
 
  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
 
  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };
 
  return (
    <div>
      <h1  className='text-center text-4xl mt-6 md:mt-20'></h1>
      <h1 className="text-2xl font-bold  md:text-5xl xl:text-5xl text-center xl:mb-20 text-slate-900">
      What Our clients say!
      </h1>
    <div className=" flex flex-col  justify-center items-center  xl:p-12 h-[200px] md:h-[500px] pt-12 px-3 ">
      {/* Image Slider */}
      <div className=" h-[200px]  md:h-[500px]">
        <img
          src={images[currentIndex]}
          alt={`slide-${currentIndex}`}
          className=" "
        />
      </div>
 
      {/* Dots Indicator */}
      <div className=" flex justify-center space-x-2 mt-6">
        {images.map((_, index) => (
          <span
            key={index}
            className={`w-2 h-2 md:w-3 md:h-3 rounded-full ${
              index === currentIndex ? 'bg-gray-400' : 'bg-gray-800'
            }`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
    </div>
  );
};
 
export default Carousel;